import { FEATURE_TOUR_IDS, Z_INDEX } from '@va/constants';
import { DropdownIcon, GlobeIcon, HelpIcon, SettingsIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { HorizontalDivider } from '@va/ui/design-system';
import { TooltipWrapper } from '@va/ui/tooltips';
import { DropdownArrow } from '@va/util/components';
import classNames from 'classnames';
import { useState } from 'react';
import LanguageSelector from '../languageSelector/LanguageSelector';
import { UserMenuButton } from './UserMenuButton';
import { useUserMenu } from './useUserMenu';

export function WebsiteMenu() {
  const translate = useTranslate();
  const { isExpanded, toggleExpanded, closeMenu } = useUserMenu();
  const [isLanguageSelectorVisible, setIsLanguageSelectorVisible] = useState(false);

  const handleLanguageSelectorToggle = () => setIsLanguageSelectorVisible((prev) => !prev);
  return (
    <TooltipWrapper
      open={isExpanded}
      onOpenChange={(open) => toggleExpanded(open)}
      trigger='click'
      zIndex={Z_INDEX.userMenu}
      tooltipClassNames='shadow-md rounded-24'
      content={
        <div className='min-w-[25rem] rounded-24 bg-white border-2 border-gray-mercury text-black px-3 py-3'>
          {!isLanguageSelectorVisible ? (
            <>
              <UserMenuButton
                leftIcon={<GlobeIcon color='var(--color-black)' />}
                text={translate('locale.language')}
                rightIcon={<DropdownIcon />}
                onClick={handleLanguageSelectorToggle}
              />
              <HorizontalDivider />

              <a href={translate('supportCenter.rootPage')} target='_blank' rel='noreferrer' onClick={closeMenu}>
                <UserMenuButton leftIcon={<HelpIcon />} text={translate('button.helpCenter')} />
              </a>
            </>
          ) : (
            <LanguageSelector
              onBackClick={handleLanguageSelectorToggle}
              onLanguageSelected={() => {
                handleLanguageSelectorToggle();
                closeMenu();
              }}
            />
          )}
        </div>
      }
      arrow={false}
      useDefaultStyle={false}
    >
      <div
        data-tour={FEATURE_TOUR_IDS.userMenu}
        className={classNames(
          'mr-4u sm-initial:mr-0 sm-initial:h-9 rounded-6u bg-primary-lighter-06 hover:bg-primary-lighter-13 sm-initial:p-6u flex justify-between items-center cursor-pointer',
          { isOpen: isExpanded },
        )}
      >
        <SettingsIcon />
        <DropdownArrow open={isExpanded} className='hidden sm-initial:block sm-initial:ml-2' />
      </div>
    </TooltipWrapper>
  );
}
